/* eslint-disable */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import scLogo from '../assets/Logo.png';
import '../styles/GoogleCallback.css';

function GoogleLoginCallback() {
  const googleLogo = 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png';
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const code = params.get('code');

        if (!code) {
          setError('Authorization code not found');
          setLoading(false);
          return;
        }

        const response = await api.googleLoginCallback(code);
        if (response?.pre_onboarded === true) {
          Cookies.set('sc_Token', response.access_token);
          localStorage.setItem('user_id', response.user_id);
          navigate("/user-details");
        } else if (response?.manual === true) {
          try {
            const data = JSON.parse(response.message);
            if (data.is_error || data?.is_error === 'true') {
              const errorMessage = data.error || data.message || 'An error occurred during Login';
              
              if (errorMessage.includes('User not found! Signup first!')) {
                toast.error('User not found! Please signup first.');
                setTimeout(() => {
                  navigate('/signup');
                }, 1500);
              } else {
                setError(errorMessage);
                toast.error(errorMessage);
                setTimeout(() => {
                  navigate('/');
                }, 2000);
              }
            }
          } catch (err) {
            console.error('Error parsing manage data:', err);
          }
        } else {
          let userData = encodeURIComponent(JSON.stringify(response));
          const savedContent = localStorage.getItem('content');
          if (savedContent) {
            userData = encodeURIComponent(JSON.stringify({ ...response, route: `/dashboard/ai-agents/agent?content=${savedContent}` }));
            localStorage.removeItem('content');
          }
          window.open(`${process.env.REACT_APP_MAIN_URL}/login?user=${userData}`, '_self');
        }
      } catch (error) {
        console.error('Google login callback error:', error);
        setError('Failed to login with Google. Please try again.');
        setLoading(false);
      }
    };

    handleGoogleCallback();
  }, [navigate]);

  return (
    <div className="google-callback-container">
      <div className="google-callback-box">
        <div className="logos">
          <img src={scLogo} alt="SalesCaptain Logo" className="sc-logo" />
          <div className="connecting-line"></div>
          <img src={googleLogo} alt="Google Logo" className="google-logo" />
        </div>
        
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Logging in with your Google account...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button 
              className="retry-button"
              onClick={() => navigate('/')}
            >
              Back to Login
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default GoogleLoginCallback; 